"use client";

import { useState, useRef } from "react";

function Tooltip({ text, children }) {
  const wrapperRef = useRef(null);
  const [openTooltip, setOpenTooltip] = useState(false);

  const handleMouseEnter = () => setOpenTooltip(true);
  const handleMouseLeave = (e) => {
    if (!wrapperRef.current?.contains(e.relatedTarget)) {
      setOpenTooltip(false);
    }
  };

  return (
    <div
      ref={wrapperRef}
      className="jlt-relative"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div>{children}</div>
      {openTooltip && (
        <span
          className="jlt-absolute jlt-bg-[#1d1d1d] jlt-text-[#f1f1f1] jlt-text-xs jlt-py-2 jlt-px-3 jlt-rounded jlt-bottom-6 jlt-w-52 -jlt-translate-x-[97px] after:jlt-content-[''] after:jlt-absolute after:jlt-top-full after:jlt-left-1/2 after:jlt-transition-opacity after:jlt-ml-[-5px] after:jlt-border-[5px] after:jlt-border-t-black after:jlt-border-r-transparent after:jlt-border-b-transparent after:jlt-border-l-transparent"
          dangerouslySetInnerHTML={{ __html: text }}
        />
      )}
    </div>
  );
}

export default Tooltip;

// content: " ";
// position: absolute;
// top: 100%;
// left: 50%;
// transition: opacity .2s;
// margin-left: -5px;
// border-width: 5px;
// border-style: solid;
// border-color: black transparent transparent transparent;
